module.exports = __webpack_public_path__ + "static/media/moons_kit_que_incluye.3c0ca2de.jpg";